import React from 'react'

import { useDecision } from '@optimizely/react-sdk'
import { useDispatch } from 'react-redux'

import { MyGoustoPage } from '@features/my-gousto-page'
import { MyHomePage } from '@features/my-home-page'

import { actionTypes } from 'actions/actionTypes'
import actions from 'actions/user'

import { ReferAFriendContainer } from './ReferAFriendContainer'

export const MyGousto = () => {
  const dispatch = useDispatch()
  const [decision] = useDecision('rockets_my_gousto_new_home_page_experiment')
  const isMyHomePageEnabled = decision.variationKey === 't1'
  const dispatchCancelOrder = (orderId: string) => {
    dispatch({
      type: actionTypes.ORDER_CANCEL,
      orderId,
      restorable: false,
    })
  }
  const dispatchRefreshOrdersState = () => {
    dispatch(actions.userLoadOrdersForMyGousto(true))
  }

  return (
    <div>
      {isMyHomePageEnabled ? (
        <div data-testid="my-home-page">
          <MyHomePage />
        </div>
      ) : (
        <>
          {/*
            Keep this selector at the route level so app and Cypress tests can
            target the control branch without changing @features/my-gousto-page.
            The feature-modules CI job runs `yarn workspaces foreach` over changed
            `@features/*` workspaces since the branch point, so touching that
            workspace would make its isolated unit suite run as well. That is
            undesirable here because this route-only change would then inherit
            unrelated feature-workspace test/dependency failures.
          */}
          <div data-testid="my-gousto-page">
            <MyGoustoPage
              dispatchCancelOrder={dispatchCancelOrder}
              dispatchRefreshOrdersState={dispatchRefreshOrdersState}
            />
          </div>
          <ReferAFriendContainer />
        </>
      )}
    </div>
  )
}
